import React from "react";
import { LoaderCircle } from "lucide-react";

export const Spinner = () => {
  return <LoaderCircle width={24} className="animate-spin" />;
};
